import { ref, type Ref } from 'vue';

// Bridges the Monaco "Create secret from this value…" code action to the app-root
// NewSecretDialog. Unlike the other prompts this one is round-trip: the editor needs the
// created reference back so it can rewrite the literal value to { "$__secret": "ref" }.
//
// The onCreated callback is held module-side (closures can't travel through a Monaco
// command's serialisable argument array) — the command builds it with the model + range
// in scope, App.vue invokes it via resolveSecretFromValue when the dialog reports the
// created reference.

export const secretFromValueRequest: Ref<{ slot: string; value: string } | null> = ref(null);

let resolver: ((reference: string) => void) | null = null;

export function requestSecretFromValue(p: {
  slot: string;
  value: string;
  onCreated: (reference: string) => void;
}): void {
  resolver = p.onCreated;
  secretFromValueRequest.value = { slot: p.slot, value: p.value };
}

// Dialog reported a successfully-created secret — run the editor replacement, then clear.
export function resolveSecretFromValue(reference: string): void {
  const cb = resolver;
  resolver = null;
  secretFromValueRequest.value = null;
  cb?.(reference);
}

// Dialog dismissed without creating — drop the pending replacement.
export function clearSecretFromValueRequest(): void {
  resolver = null;
  secretFromValueRequest.value = null;
}
